import { useState, useEffect } from "react";
import RightSidebar from "../../components/EmployerSideBar/employersidebar";
import EmployerBannersProfile from "../../components/bannersprofile/employerprofilebanner";
import Postedvacancies from "../../components/postedvacancies/postedvacancies";
import bannimage from "../../assets/Mainbanner/main.png";

const EmployerProfile = () => {
  const [cover, setCover] = useState("default-cover.jpg");
  const [profile, setProfile] = useState("default-avatar.png");
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Получаем ID пользователя из localStorage
    const userId = localStorage.getItem("userId");

    if (!userId) {
      console.error("User ID not found in localStorage");
      return;
    }

    fetch(`/api/get_user.php?id=${userId}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.user) {
          const updatedUser = { ...data.user };

          if (data.user.photo) setProfile(data.user.photo);
          if (data.user.cover) setCover(data.user.cover);
          
          // Синхронизируем стейт
          setUser(updatedUser);
        }
      })
      .catch((err) => console.log("Fetch user error:", err));
  }, []);

  const handleUpload = (e, type = "photo") => {
    if (!user) return;

    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("id", user.id);
    // Отправляем тип на бэкенд, чтобы PHP знал, какое поле в БД обновлять (logo, background или photo)
    formData.append("type", type); 

    fetch("/api/employeruploadphoto.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          // Динамически обновляем поле внутри объекта user в зависимости от типа загрузки
          setUser((prev) => ({ 
            ...prev, 
            [type]: data.file 
          }));

          // Обновляем отдельные стейты для превью
          if (type === "photo") setProfile(data.file);
          if (type === "cover") setCover(data.file);
          if (type === "background") setCover(data.file); // на случай если поле называется background
          if (type === "companyLogo") console.log("Company Logo updated успешно!");
        } else {
          console.error("Upload error:", data.message, data.error);
        }
      })
      .catch((err) => console.error("Network error during upload:", err));
  };

  // Пока данные не пришли — показываем аккуратный лоадер
  if (!user) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-lg text-gray-500">Loading...</p>
      </div>
    );
  }

  return (
    <div className="md:flex opacity-0 animate-[showtitle_1s_forwards]">
      <section className="flex-1 p-6 max-md:p-0 max-sm:pt-1">
        <aside className="relative overflow-hidden w-[300px] max-md:w-full h-auto flex justify-center p-6 pt-1 items-start flex-col gap-3 rounded-[30px] max-md:rounded-none shadow-2xl">
          <div
            className="absolute size-full inset-0 bg-cover bg-left"
            style={{
              backgroundImage: `url(${bannimage})`,
            }}
          ></div>
          
          <div className="absolute inset-0 bg-black/10 backdrop-blur-[40px] z-10"></div>
          
          <header className="relative z-10 opacity-0 animate-[showtitle_1s_forwards] w-full h-auto flex-col flex justify-start items-start pt-3 gap-6">
            <div className="max-md:flex justify-start items-center gap-6 w-full">
              <div>
                <div className="w-[150px] h-[150px] max-md:translate-x-0 relative shadow-2xl">
                  <img
                    src={`/api/uploads/${user.companyLogo || profile}`}
                    alt="Company Logo"
                    className="w-full h-full flex justify-center items-center bg-gray-200 rounded-2xl object-cover"
                  />
                  <label className="absolute -bottom-3 -right-3 p-1 bg-white rounded-full shadow cursor-pointer z-20">
                    📷
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => handleUpload(e, "companyLogo")}
                    />
                  </label>
                </div>
              </div>
              <div className="flex w-full flex-col gap-3 mt-3">
                <h1 className="text-2xl text-white font-bold break-words whitespace-normal">
                  {user.companyName || "No Name"}
                </h1>
                <h4 className="text-xl text-white">ID: {user.id}</h4>
              </div>
            </div>
          </header>
          <RightSidebar/>
        </aside>
      </section>

      <section className="flex w-full flex-col gap-6 max-md:gap-3">
        <EmployerBannersProfile/>
        <section>  
          <Postedvacancies userId={user.id}/>
        </section>
      </section>
    </div>
  );
};

export default EmployerProfile;